document.addEventListener('gform/postRender', (event) => {
	const form = gform.utils.getNode(`#gform_${event.detail.formId}`, document, true);
	const inputs = Array.from(gform.utils.getNodes('.gf_readonly input', false, form, true));

	inputs.forEach(input => {
		input.readOnly = true;
	});
});